"use client";

import { AdvertisementBlockType, PageAdBlocksTypes } from "@/types/page";
import AdBanner from "../GoogleAdSense/AdBanner";
import { AdTypeEnum } from "@/types/common";
import envConfig from "@/config/envConfig";

export default function AdvertisementBlock({
  block,
  advertisementData,
}: {
  block: AdvertisementBlockType;
  advertisementData?: PageAdBlocksTypes;
}) {
  const isVertical = block?.adType === "vertical";
  const isHorizontal = block?.adType === "horizontal";

  return (
    <div className="w-full">
      <div
        className={
          isVertical
            ? "w-full"
            : isHorizontal
              ? "w-full"
              : "mx-auto w-full max-w-[350px] aspect-square"
        }
      >
        <div className="w-full">
          {envConfig.enableAds === "true" ? (
            advertisementData?.adType === AdTypeEnum.DAILYHUNT ||
            advertisementData?.adType === AdTypeEnum.GOOGLE ||
            advertisementData?.adType === AdTypeEnum.CUSTOM ? (
              <AdBanner
                advertisementData={advertisementData}
                layout={isVertical ? "vertical" : "default"}
              />
            ) : (
              <AdBanner
                layout={isVertical ? "vertical" : "default"}
                dataAdSlot={
                  isVertical ? "6237932871" : isHorizontal ? "6420662056" : "5574484243"
                }
              />
            )
          ) : isHorizontal ? (
            <img
              src="/images/temp/thumbnailHorizontal.png"
              alt="ad"
              className="block h-auto w-full object-contain"
            />
          ) : (
            <></>
          )}
        </div>
      </div>
    </div>
  );
}
